import React from 'react';
import { Icon } from 'src/components/icon/icon';
import { Text } from 'src/components/text/Text';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { type InstallmentOffer } from 'src/types/widget-offers';
import { getSubventionFaqLink } from 'src/utils/get-subvention-faq-link';

import styles from './styles.css';

type Props = {
  offer: InstallmentOffer;
};

export const SubventionFaqLink = ({ offer }: Props) => {
  const t = useLocale();
  const { lang, currency } = useAppContext();
  const country = COUNTRY_BY_CURRENCY_MAP[currency];

  const handleClick = () => {
    const faq = getSubventionFaqLink(
      lang,
      country,
      offer.subventionCampaignId as string
    );

    window.open(faq, '_blank');
  };

  return (
    <div className={styles.container} onClick={handleClick}>
      <Text as="span" variant="body1Loose">
        {t('learn_more_about_this_offer')}
      </Text>
      <div className={styles.arrowIcon}>
        <Icon name="arrow" />
      </div>
    </div>
  );
};
